import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SubStatusesService } from '../sub-statuses/sub-statuses.service';
import moment from 'moment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';
import { identifierName } from '@angular/compiler';
import {DatePipe} from "@angular/common";

@Component({
    selector: 'sub-status-datepicker',
    templateUrl: './sub-status-datepicker.component.html',
    styleUrls: ['./sub-status-datepicker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubStatusDatepickerComponent {
  @Input() substatusDate: any;
  @Input() substatus: any;
  @Input() subsequence: any;
  @Input() project_status_id: number;
  @Input() slim: boolean = false;
  public formattedDate: string;
  public today: string;

  @Output() changeSubstatusDate = new EventEmitter<any>();
  constructor(
    public substatusService: SubStatusesService,
    private dialog: MatDialog,
    private datePipe: DatePipe
  ) {}
  ngOnChanges() {
    if (!this.substatusDate) {
      this.substatusDate = this.substatusService.generateDummyDate({subsequence_id: this.subsequence.id, substatus_id: this.substatus.id, project_status_id: this.project_status_id});
    }
    this.formattedDate =
      this.substatusDate.date?.length > 0
        ? new Date(
            this.datePipe.transform(this.substatusDate.date, 'MM/dd/yyyy') ?? new Date()
          ).toISOString()
        : '';
    this.today = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-dd') ?? new Date()).toISOString()
  }
  changeDate(event: any) {
    let newDate = null;
    if (event.value !== null) {
      let dateArr = [
        event.value.toLocaleDateString("en-US", {year: 'numeric'}),
        event.value.toLocaleDateString("en-US", {month: 'numeric'}),
        event.value.toLocaleDateString("en-US", {day: 'numeric'})
      ]
      newDate = dateArr.join('-')
    }
    let today = this.datePipe.transform(Date.now(), 'yyyy-MM-dd')
    this.substatusDate.date = newDate;
    if (today && newDate && (newDate > today)) {
      this.substatusDate.target = true;
    }
    this.substatusService.queueProjectSubstatusDateUpdate(this.substatusDate);
    this.changeSubstatusDate.emit(this.substatusDate);
  }
  prettifyDate(date: string | null) {
    let newDate = '-';
    if (date) {
      newDate = this.datePipe.transform(date, 'yyyy-MM-dd') || ""
    }
    return newDate;
  }
  changeTarget(event: any) {
    if (event.checked !== null && this.substatusDate.date?.length > 0) {
      this.substatusDate.target = event.checked;
      this.substatusService.queueProjectSubstatusDateUpdate(this.substatusDate);
    }
  }
  deleteDateConfirmation() {
    if (this.substatusDate.id) {
      const ref: MatDialogRef<ConfirmationModalComponent> = this.dialog.open(
        ConfirmationModalComponent,
        {
          width: '600px',
          height: '380px',
          data: {
            modalTitle: 'Delete Pipeline Milestone Date',
            actionMessage:
              'Are you sure you want to delete the Pipeline Milestone Date?',
            modalInformation: [
              {
                title: 'Subsequence',
                info: this.subsequence.name,
              },
              {
                title: 'Substatus',
                info: this.substatus.name,
              },
              {
                title: 'Target',
                info: this.substatusDate.target ? 'Yes' : 'No',
              },
              {
                title: 'Date',
                info: this.prettifyDate(this.substatusDate.date),
              },
            ],
          },
          backdropClass: 'confirmDialogComponent',
          hasBackdrop: true,
        }
      );
      ref.afterClosed().subscribe((data: any) => {
        if (data?.clicked === 'Ok') {
          let id = this.substatusDate.id;
          this.substatusDate = this.substatusService.generateDummyDate({subsequence_id: this.subsequence.id, substatus_id: this.substatus.id, project_status_id: this.project_status_id});
          this.substatusService.deleteProjectSubstatusDates(
            id,
            this.substatusDate.subsequence_id,
            this.substatusDate.substatus_id
          );
        }
      });
    } else {
      this.substatusService.deleteProjectSubstatusDates(
        this.substatusDate.id,
        this.substatusDate.subsequence_id,
        this.substatusDate.substatus_id
      );
      this.substatusDate = this.substatusService.generateDummyDate({subsequence_id: this.subsequence.id, substatus_id: this.substatus.id, project_status_id: this.project_status_id});
    }
  }
}
